import { render } from "./detail-dokumentasi.vue?vue&type=template&id=306e12eb"
import script from "./detail-dokumentasi.vue?vue&type=script&lang=js"
export * from "./detail-dokumentasi.vue?vue&type=script&lang=js"

import "./detail-dokumentasi.vue?vue&type=style&index=0&id=306e12eb&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__